import React from "react";
import {CommonPhone} from "../pages/types";

interface Props {
    telephone:CommonPhone
    show:boolean,
    onClose:() => void
}

const MakePhoneCall:React.FC<Props> = (props) =>{
    if(!props.show){
        return null
    }
    return <div className='phoneCall'>
        <div className="box">
            <a className="item" href={ `tel:${ props.telephone.areaCode }${ props.telephone.telephone }` }>
                <p className="iconfont">&#xe621;</p>

                <p className="n">呼叫 <span>{ props.telephone.areaCode } { props.telephone.telephone }</span></p>
            </a>
            <div className="item cancel" onClick={ props.onClose }>取消</div>
        </div>
    </div>
}

export default MakePhoneCall
